# The sound layer hands a loaded buffer to the instances waiting for it —
# card 6aab65a36c29c3a6dc3bbbb7.
#
# THE DEFECT IS IN THE LIBRARY. createjs 1.0.0's AbstractPlugin does this when a
# sound finishes preloading (builds/1.0.0/createjs.js, _handlePreloadComplete):
#
#     for (var i = 0, l = this._soundInstances[src].length; i < l; i++) {
#       var item = this._soundInstances[src][i];
#       item.setPlaybackResource(this._audioSources[src]);
#       this._soundInstances[src] = null;
#     }
#
# Two things are wrong with it. `setPlaybackResource` was replaced by the
# `playbackResource` PROPERTY in 0.6.0 — AbstractSoundInstance defines it with
# Object.defineProperty and no method of that name survives — so the call throws
# `setPlaybackResource is not a function` for any instance that is waiting. And
# the array is nulled INSIDE its own loop, so even a working call would only
# ever reach the first instance.
#
# WHEN IT RUNS. Only when a sound is PLAYED BEFORE ITS FILE HAS FINISHED
# LOADING: that is what puts an instance in `_soundInstances[src]` for the load
# to hand a buffer to. Measured on QA elfeet 2026-09-17, Knights at 932x430:
# five `Failed to play enter [knight_move.mp3] (playState indicates failure)`
# lines — loopback_api's `play` retrying an enter sound whose file was still in
# flight — and then an uncaught page error out of soundjs. It was the only
# uncaught error in 46 game plays.
#
# WHY IT MATTERS BEYOND THE CONSOLE LINE. The throw aborts the handoff, so the
# instances waiting on that file never receive their buffer at all: a sound
# played early stays silent for the rest of the session. That is the path a real
# device takes when the first play is refused — iOS autoplay policy is the
# ordinary case, not an exotic one.
#
# WHY A PATCH AND NOT AN UPGRADE. createjs 1.0.0 is the last release; the bug is
# still in it. This replaces the one method, on the prototype every plugin
# inherits it from, with the same method written correctly.
#
# ORDERING IS LOAD-BEARING. `AbstractPlugin.register` captures
# `this._handlePreloadComplete` as the loader's complete listener, so a sound
# registered before this runs would keep the broken one. It is called at module
# scope from each shell's app-route — the webpack entry — which is before any
# game, avatar picker or instruction set can register a sound.
import createjs from 'createjs'

export patchPlaybackResourceHandoff = (cjs = createjs) ->
  plugin = cjs?.AbstractPlugin?.prototype
  return false unless typeof plugin?._handlePreloadComplete is 'function'
  return false if plugin._playbackResourceHandoffPatched

  plugin._handlePreloadComplete = (event) ->
    src = event?.target?.getItem?()?.src
    return unless src?
    @_audioSources[src] = event.result
    waiting = @_soundInstances?[src]
    if waiting?.length
      for item in waiting when item?
        try
          # The property, which is what 1.0.0 actually has. The method call is
          # kept as the first branch only so a future createjs that restores it
          # is handled by the same code.
          if typeof item.setPlaybackResource is 'function'
            item.setPlaybackResource @_audioSources[src]
          else
            item.playbackResource = @_audioSources[src]
        catch e
          # One instance that cannot take the buffer must not cost the others
          # theirs, and must never reach the page as an uncaught error.
          console.warn "Could not hand the loaded buffer to a sound instance for #{src}: #{e?.message}"
    # AFTER the loop, not inside it (see above).
    @_soundInstances[src] = null if @_soundInstances?
    return

  plugin._playbackResourceHandoffPatched = true
  true
